import React from 'react';
import ReactDOM from 'react-dom';
import { Form, Input, DatePicker, TimePicker, Select, Cascader, InputNumber } from 'antd';
import { Row, Col, Slider } from 'antd';
import { message } from 'antd';
// import { text_mk } from './formCtlMK/SgiTextMaker';
import { addCtnCommonAttribute } from "./SgiCtnComm"
import { convertModuleByGuid } from "./SgiCompComm"
import { PrmFactory } from 'rt-sd-common/sgiFactory/PrmFactory'
import { Resource } from 'rt-sd-common/sgiFactory/Resource';
import { getJsonLength } from 'rt-sd-common/sgiCommon/sgiCommon';
import { AllCompGUID } from 'rt-sd-common/sgiConstants/SgiCompConstant';
const FormItem = Form.Item;

class SgiTableEditorCell extends React.Component {

  //这个暂时不好用 以后在处理
  static defaultProps = {
  };  // 注意这里有分号
  static propTypes = {
  };

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {

    let { moduleDesc, tableBDInst, objFct, record } = this.props;
    if (!moduleDesc.mdType || moduleDesc.mdType == 'text') {
      moduleDesc.desId = AllCompGUID.FIELDTEXT;
    } else if (moduleDesc.mdType == 'combox') {
      moduleDesc.desId = AllCompGUID.COMBOBOX;
    } else if (moduleDesc.mdType == 'num') {
      moduleDesc.desId = AllCompGUID.NUMBER;
    } else if (moduleDesc.mdType == 'time') {
      moduleDesc.desId = AllCompGUID.TIME;
    } else if (moduleDesc.mdType == 'date') {
      moduleDesc.desId = AllCompGUID.DATE;
    } else if (moduleDesc.mdType == 'ckbox') {
      moduleDesc.desId = AllCompGUID.CHECKBOX;
    } else if (moduleDesc.mdType == 'area') {
      moduleDesc.desId = AllCompGUID.AREA;
    } else {
      moduleDesc.desId = AllCompGUID.FIELDTEXT;
    }

    moduleDesc.isLbl = true;
    moduleDesc.c = moduleDesc.dataIndex;
    // objFct.set(tableBDInst, record);

    return (
      <div className="editable-cell">
        {/* {convertModuleByGuid(this, this.props.moduleDesc, tableBDInst, objFct, 'tb')} */}
        {convertModuleByGuid(this, this.props.moduleDesc, record, objFct, 'tb')}
      </div>
    );
  }
}

export default SgiTableEditorCell;


// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiTableEditorCell.js